<script setup>
import { useApi } from '@/utils/api'

// Module 16 (§9.3) — pandangan MFK atas Facility, read-only (CRUD lengkap
// tetap di pages/master-data/facilities/index.vue, gerbang master-data.manage
// — sama pemisahan seperti pages/hr/employees/index.vue & governance/sk).
// Reuse GET /api/v1/master-data/facilities apa adanya, tidak ada endpoint baru.
definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Mfk',
  },
})

const typeLabels = {
  building: 'Gedung',
  room: 'Ruangan',
  electrical: 'Kelistrikan',
  genset: 'Genset',
  ipal: 'IPAL',
  other: 'Lainnya',
}

const items = ref([])
const loading = ref(false)
const totalItems = ref(0)
const page = ref(1)
const perPage = ref(15)
const search = ref('')

const fetchItems = async () => {
  loading.value = true
  try {
    const query = { page: page.value, per_page: perPage.value }
    if (search.value) query.search = search.value

    const response = await useApi('/api/v1/master-data/facilities', { query }).get()
    const data = response?.data ?? response

    items.value = Array.isArray(data) ? data : (data?.data ?? [])
    totalItems.value = response?.meta?.total ?? data?.meta?.total ?? 0
  } catch (e) {
    console.error('Fetch facilities error:', e)
  } finally {
    loading.value = false
  }
}

onMounted(fetchItems)
watch(search, () => { page.value = 1; fetchItems() })
watch(page, fetchItems)

const headers = [
  { title: 'Kode', key: 'code', width: 130 },
  { title: 'Nama', key: 'name' },
  { title: 'Jenis', key: 'type', align: 'center', width: 150 },
  { title: 'Unit', key: 'unit' },
  { title: 'Lokasi', key: 'location' },
]
</script>

<template>
  <div>
    <VRow class="mb-4">
      <VCol cols="12">
        <h4 class="text-h4 font-weight-bold">
          Fasilitas
        </h4>
        <p class="text-body-2 text-medium-emphasis mb-0">
          Gedung, ruangan, dan sarana MFK lainnya (§9.3) — kelola data lewat Master Data &gt; Fasilitas
        </p>
      </VCol>
    </VRow>

    <VCard class="mb-4">
      <VCardText>
        <VTextField
          v-model="search"
          placeholder="Cari nama atau kode fasilitas..."
          prepend-inner-icon="ri-search-line"
          clearable
          hide-details
          density="compact"
          style="max-width: 320px;"
        />
      </VCardText>
    </VCard>

    <VCard>
      <VDataTable
        :headers="headers"
        :items="items"
        :loading="loading"
        :items-per-page="perPage"
        hide-default-footer
      >
        <template #item.type="{ item }">
          <VChip
            size="small"
            variant="tonal"
          >
            {{ typeLabels[item.type] ?? item.type }}
          </VChip>
        </template>
        <template #item.unit="{ item }">
          {{ item.unit?.name ?? '-' }}
        </template>
        <template #item.location="{ item }">
          {{ item.location ?? '-' }}
        </template>
        <template #no-data>
          <div class="text-center py-10">
            <p class="text-medium-emphasis">
              Belum ada data fasilitas
            </p>
          </div>
        </template>
      </VDataTable>
      <VDivider />
      <VCardText class="d-flex align-center justify-space-between flex-wrap gap-3 pa-4">
        <span class="text-body-2 text-medium-emphasis">Total: {{ totalItems }}</span>
        <VPagination
          v-if="totalItems > perPage"
          v-model="page"
          :length="Math.ceil(totalItems / perPage)"
          :total-visible="5"
          density="compact"
        />
      </VCardText>
    </VCard>
  </div>
</template>
